
export default {
  name: "CaixaEspecies",
  props: {
    titulo: { type: String, required: true },
    mensagemVazia: { type: String, required: true },
    pagamentos: { type: Array, default: () => [] },
    formatarValor: { type: Function, required: true },
  },
  computed: {
    especiesVisiveis() {
      return (this.pagamentos || []).filter(
        (pagamento) => pagamento && Number(pagamento.total) > 0
      );
    },
  },
};
